import React from 'react'
import './index.css'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import Flex from 'components/Flex'
import useSelector from 'hooks/use-selector'
import getMembersSquadSelect from 'modules/squad/redux/selectors/get-members'
import ButtonTextPrimary from 'components/ButtonTextPrimary'
import classNames from 'classnames'
import Button from 'components/Button'
import getNextMemberIdSquadSelect from 'modules/squad/redux/selectors/get-next-member-id'
import getPreviousMemberIdSquadSelect from 'modules/squad/redux/selectors/get-previous-member-id'
import Popover from 'components/Popover'
import Span from 'components/Span'
import FlexColumn from 'components/FlexColumn'
import PreviousButton from 'components/PreviousButton'
import NextButton from 'components/NextButton'
import logUtil from 'utils/log'
import getCurrentMemberIdSquadSelect from 'modules/squad/redux/selectors/get-current-member-id'
import { ROUTE_PATH } from 'modules/route/constants'
import Link from 'components/Link'
import { throttle } from 'lodash'
import getMemberNameSquadUtil from 'modules/squad/utils/get-member-name'

const SELECT_A_FRIEND = 'Select a friend'
const ANALYTICS_EVENT = {
  SQUAD_SELECT_A_FRIEND: 'SQUAD_SELECT_A_FRIEND',
  SQUAD_ADD_A_NEW_FRIEND: 'SQUAD_ADD_A_NEW_FRIEND'
}

const ADD_A_NEW_FRIEND = 'Add a new friend'

const POPOVER_ID = 'SQUAD_SELECT_A_FRIEND'

const SCROLL_THROTTLE_DELAY = 500
export default function SquadPageSelectAFriend (props) {
  /**
   * @type {import('modules/squad/types').GetSquadInfoResp.squad_members}
   */
  const members = useSelector(getMembersSquadSelect)
  const nextMemberId = useSelector(getNextMemberIdSquadSelect)
  const currentMemberId = useSelector(getCurrentMemberIdSquadSelect)
  const previousMemberId = useSelector(getPreviousMemberIdSquadSelect)
  const [isSelected, setIsSelected] = React.useState(false)
  const ref = React.useRef()
  const debugProps = {
    members,
    nextMemberId,
    currentMemberId,
    previousMemberId
  }

  logUtil('SquadPageSelectAFriend').debug('[start] debugProps=', debugProps)

  const handleSelectAFriend = () => {
    logUtil('SquadPageSelectAFriend#handleSelectAFriend').debug('[start]')
    logEventAnalyticsUtil(ANALYTICS_EVENT.SQUAD_SELECT_A_FRIEND)
    setIsSelected(!isSelected)
  }

  const closePicker = () => {
    setIsSelected(false)
  }
  const handleClickPrevious = () => {
    logUtil('SquadPageSelectAFriend#handleClickPrevious').debug('[start]')
    closePicker()
    props.onClickPrevious()
  }
  const handleClickNext = () => {
    logUtil('SquadPageSelectAFriend#handleClickNext').debug('[start]')
    closePicker()
    props.onClickNext()
  }

  const handlePressClosePopover = () => {
    closePicker()
  }

  const handleClickFriend = (index) => {
    logUtil('SquadPageSelectAFriend#handleClickFriend').debug(`[start] index=${index}`)
    props.onClickFriend(index)
    closePicker()
  }

  const handleClickAddANewFriend = () => {
    logUtil('SquadPageSelectAFriend#handleClickFriend').debug('[start]')
    logEventAnalyticsUtil(ANALYTICS_EVENT.SQUAD_ADD_A_NEW_FRIEND)
    closePicker()
  }

  const icon = isSelected
    ? (
      <svg
        width='21'
        height='20'
        viewBox='0 0 21 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M13.8333 12.2917C13.6733 12.2917 13.5133 12.2309 13.3916 12.1084L10.5 9.21678L7.60834 12.1084C7.36417 12.3526 6.96831 12.3526 6.72414 12.1084C6.47997 11.8643 6.47997 11.4684 6.72414 11.2242L10.0575 7.89089C10.3016 7.64672 10.6975 7.64672 10.9417 7.89089L14.275 11.2242C14.5192 11.4684 14.5192 11.8643 14.275 12.1084C14.1533 12.2309 13.9933 12.2917 13.8333 12.2917Z'
          fill='#E15EC4'
        />
      </svg>
      )
    : (
      <svg
        width='20'
        height='21'
        viewBox='0 0 20 21'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M10 12.3247C9.84002 12.3247 9.68 12.2639 9.55833 12.1414L6.225 8.80804C5.98083 8.56388 5.98083 8.16801 6.225 7.92385C6.46916 7.67968 6.86502 7.67968 7.10919 7.92385L10.0008 10.8155L12.8925 7.92385C13.1366 7.67968 13.5325 7.67968 13.7767 7.92385C14.0208 8.16801 14.0208 8.56388 13.7767 8.80804L10.4433 12.1414C10.32 12.2639 10.16 12.3247 10 12.3247Z'
          fill='#E15EC4'
        />
      </svg>
      )

  const handleScroll = () => {
    logUtil('SquadPageSelectAFriend#handleScroll').debug('[start]')
    closePicker()
  }

  const throttledScrollRef = React.useRef(
    throttle(handleScroll, SCROLL_THROTTLE_DELAY)
  )
  React.useEffect(() => {
    document.addEventListener('scroll', throttledScrollRef.current)
    return () => {
      document.removeEventListener('scroll', throttledScrollRef.current)
    }
  }, [])

  return (
    <Flex className='squad-select-a-friend'>
      <PreviousButton
        disabled={!previousMemberId}
        onClick={handleClickPrevious}
      />
      <ButtonTextPrimary
        onClick={handleSelectAFriend}
        ref={ref}
        className={
          classNames({
            'squad-select-a-friend-picker': true,
            'squad-select-a-friend-picker_selected': isSelected
          })
        }
      >
        {SELECT_A_FRIEND} {icon}
      </ButtonTextPrimary>
      <Popover
        id={POPOVER_ID}
        open={isSelected}
        anchorEl={ref.current}
        onClose={handlePressClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <FlexColumn className='squad-select-a-friend-picker-content'>
          {
            members.map((member, index) => {
              const id = member.squad_member_customer_id
              return (
                <Button
                  key={id}
                  className={
                    classNames({
                      'squad-select-a-friend-picker-content-item': true,
                      'squad-select-a-friend-picker-content-item_selected': currentMemberId === id
                    })
                  }
                  onClick={() => handleClickFriend(index)}
                >
                  <Span>{getMemberNameSquadUtil(member)}</Span>
                </Button>
              )
            })
          }
          <Link
            className={
              classNames({
                'squad-select-a-friend-picker-content-item': true
              })
            }
            onClick={() => handleClickAddANewFriend()}
            href={ROUTE_PATH.ACCOUNT_LOYALTY}
          >
            <Span>{ADD_A_NEW_FRIEND}</Span>
          </Link>
        </FlexColumn>
      </Popover>
      <NextButton
        className='squad-select-a-friend-next'
        disabled={!nextMemberId}
        onClick={handleClickNext}
      />
    </Flex>
  )
}
